module.exports = __webpack_public_path__ + "img/home-principal.5e9c4fc0.png";